import ajax from "ajax";

const cache = function (url) {
  if (!this[url]) {
    this[url] = ajax.stream({
      type: "get",
      url: url,
      dataType: "json"
    }).toProperty();
  }
  return this[url];
}.bind({});

export default cache;



// WEBPACK FOOTER //
// ./web/js/cache.js